<template>
    <b-container>
        <div id="wbkg_wrapper" class="wbkg-wrapper">
            <div :style="componentVisibilityStyle">
                <router-view v-if="isMetadataInitialised" />
            </div>
            <toast-handler />
        </div>
    </b-container>
</template>

<script>
import { eventBus } from "@/main";
import ToastHandler from "@/components/content/ToastHandler.vue";
import { stripeRedirectParams, routerRedirectToStep } from "@/router/router-redirect";
import { pushToDataLayer } from "@/utils";

export default {
    name: "App",
    components: {
        ToastHandler,
    },
    data() {
        return {
            sessionExpiryIntervalId: false,
            isAppScratchResultVisible: false,
            strAppScratchPreContent: false,
            scratchData: null
        };
    },
    computed: {
        session() { return this.$store.getters.session; },
        clinics() { return this.$store.state.clinics.data; },
        isLocalhost() { return this.$store.getters.isLocalhost; },
        componentVisibilityStyle() { return this.showError ? { display: "none" } : { display: "block" }; },
        isMetadataInitialised() { return this.$store.getters.isMetadataInitialised; },
        isAppScratchPreContentFilled() {
            return (typeof this.strAppScratchPreContent === 'string' || this.strAppScratchPreContent instanceof String) && (this.strAppScratchPreContent != "");
        }
    },
    created() {
        this.$store.commit("initialise");
        this.$store.dispatch("getMetadata");
        this.$store.watch(
            state => state.toastMessages,
            (toastMessages) => {
                const message = toastMessages.slice(-1)[0];
                eventBus.$emit("toast", {
                    message,
                    variant: "warning"
                });
            }
        );
    },
    mounted() {
        this.$store.dispatch("initialiseSession")
            .then(() => {
                const stripe_params = stripeRedirectParams();
                if (stripe_params) {//  User just came back from Stripe redirect
                    this.$store.dispatch("processStripeRedirect", stripe_params)
                    .then(() => {
                        this.$store.commit("setSessionIsLoading", false);
                        let url;
                        url = this.isLocalhost ? "http://localhost:8080/" : "https://book.willowlife.co.uk/";

                        if(this.session?.custom_url_code) {
                            url = url + `?offer=${this.session.custom_url_code}`;
                        }

                        window.location.replace(url);
                    });
                } else {
                    const step = this.$store.getters.sessionStep;
                    const session = this.$store.getters.session;
                    // console.log(`App.mounted.session`, session);
                    

                    if (session.is_new_session) {
                        //  is_new_session is added to session by actions.initialiseSession if session code does not
                        //  match localStorage - IE if server started a new session
                        const customUrlParams = session.custom_url_json?.params ?? [];
                        const customUrlParamsForDataLayer = {};
                        customUrlParams.forEach((param) => {
                            customUrlParamsForDataLayer[param.key] = param.value;
                        });
                        pushToDataLayer("page_load", {
                            session_id: session.code,
                            custom_url_code: session.custom_url_code || "",
                            custom_url_description: session.custom_url_json?.description ?? "",
                            custom_url_price: session.custom_url_json?.price ?? null,
                            custom_url_parameters: customUrlParamsForDataLayer,
                            step,
                        });
                    }

                    routerRedirectToStep(step, session);
                }
            })
            .catch(error => {
                this.$store.commit("checkForSessionExpiredError", error);
            });

        const throttleSetScreenSizeMode = (vue) => {
            let lastCall = 0;
            return function () {
                const now = (new Date()).getTime();
                if ((now - lastCall) >= 25) {
                    lastCall = now;
                    vue.$store.commit("setWindowInnerWidth");
                }
            };
        }

        this.$store.commit("setWindowInnerWidth");
        document.body.style.marginBottom = "2rem";
        window.addEventListener('resize', throttleSetScreenSizeMode(this));
    }
};
</script>

<style language="scss">
/* @font-face {
    font-family: neo-sans;
    src: url('../public/assets/4870Neo-Sans.woff2') format('woff2'), url('../public/assets/4870Neo-Sans.woff') format('woff'); */
/* Path relative to willow-bookings/src/App..vue */
/* font-display: swap;
} */
body {
    overflow: visible;
    /* font-family: Helvetica, Geneva, Tahoma, Arial, sans-serif; */
}

div,
p,
label,
input,
select,
textarea {
    font-family: Helvetica, Geneva, Tahoma, Arial, sans-serif;
    font-weight: 400;
}

.wbkg-outer,
.wbkg-full-width {
    width: 100%;
}

.wbkg-small-text {
    font-size: 1rem;
    /* font-weight: 200; */
}

.wbkg-filter-label {
    font-weight: 600;
}

.wbkg-input,
.wbkg-text-area {
    border: 1px solid #666 !important;
    border-radius: 0.2rem !important;
    background-color: white !important;
    padding: 0.65rem !important;
}

.wbkg-input {
    height: 3rem !important;
}

.wbkg-red-text {
    color: #e16e38;
    font-weight: 300;
}

.wbkg-dark-grey {
    color: #333;
}

.wbkg-light-grey {
    color: #aaa;
}

.wbkg-bold {
    font-weight: 600;
}

.wbkg-centered {
    margin-left: auto;
    margin-right: auto;
}

::placeholder {
    color: #cccccc !important;
    font-weight: 200 !important;
}
</style>